var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMoney = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b4b4b4",
    floodOpacity: 0.471
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1107 -4797)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1107, 4797)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)",
    fill: "#fed57c",
    stroke: "#e4e4e6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 7.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1121.908 4808.908)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.185,
    height: 52.185,
    rx: 8,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.185,
    height: 35.185,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.21,15.644c-3.2-.832-4.232-1.693-4.232-3.033,0-1.538,1.425-2.61,3.809-2.61,2.511,0,3.442,1.2,3.526,2.962h3.117A5.623,5.623,0,0,0,18.9,7.589V4.5H14.671V7.547c-2.737.592-4.937,2.37-4.937,5.092,0,3.258,2.694,4.881,6.63,5.826,3.526.846,4.232,2.088,4.232,3.4,0,.973-.691,2.525-3.809,2.525-2.906,0-4.048-1.3-4.2-2.962H9.48c.169,3.089,2.483,4.824,5.191,5.4v3.061H18.9V26.858c2.751-.522,4.937-2.116,4.937-5.008C23.84,17.844,20.412,16.476,17.21,15.644Z",
    transform: "translate(0.369 1.086)",
    fill: "#fff"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoney, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Money.cb3e503e.svg";
export { ForwardRef as ReactComponent };